import Colors from '../../../assets/Colors'

export const SignatureModalStyles = {
  modal: {
    justifySelf: 'center',
    alignSelf: 'center'
  },
  container: {
    width: '398px',
    height: '265px',
    borderRadius: '3px',
    padding: '16px',
    backgroundColor: Colors.white
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  titleText: {
    fontWeight: 400,
    fontSize: '22px',
    color: Colors.napaBlue
  },
  body: { paddingBottom: '8px' },
  bodyText: { overflow: 'hidden', textOverflow: 'ellipsis'},
  image: {
    height: '129px'
  }
}
